import useSWR from "swr";

import { ErrorCodes } from "../../main/models/error-codes";
import { getErrorCodes } from "../apis/getErrorCodes";

export const useErrors = () => {
  const { data: errorCodes } = useSWR(`errorCodes`, getErrorCodes);
  return errorCodes ?? ({} as ErrorCodes);
};
